// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductFullStyles } from "@ces/Overrides/Components/ProductCarouselProductFull";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

productCarouselProductFullStyles.container = {
    gap: 0,
    css: css`
        height: 100%;

        ${GridOffset} {
            height: 100%;
        }
    `,
};

productCarouselProductFullStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            justify-content: center;
            height: 301px;
            margin-bottom: 8px;
        `,
    },
};

productCarouselProductFullStyles.productBrandWrapper = {
    css: css`
        display: flex;
    `,
};

productCarouselProductFullStyles.availabilityGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 4px;
        }
    `,
};

productCarouselProductFullStyles.quantityOrderedGridItem = {
    width: 5,
};

productCarouselProductFullStyles.addToGridItem = {
    width: 7,
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
    `,
};

productCarouselProductFullStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            margin-bottom: 0;
        `,
    },
};

productCarouselProductFullStyles.productPartNumbersStyles = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};

productCarouselProductFullStyles.textBadgeGridItem = {
    width: 12,
    css: css`
        &&& {
            gap: 12px;
            margin-bottom: 12px;
            min-height: 24px;
        }
    `,
};

productCarouselProductFullStyles.quantityInfoContainer = {
    width: 12,
    css: css`
        &&& {
            margin: 8px 0;
        }
    `,
};

productCarouselProductFullStyles.productStandardActionsContainer = {
    gap: 6,
};

productCarouselProductFullStyles.productPriceStyles = {
    quoteMessage: {
        text: {
            size: "18px",
            lineHeight: "22px",
        },
    },
};

productCarouselProductFullStyles.productActionsContainer = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
        gap: 8px;
    `,
};

productCarouselProductFullStyles.productQuantityStyles = {
    editableQuantityTextField: {
        css: css`
            width: 93px;
        `,
    },
    wrapper: {
        css: css`
            width: 100px;
            min-width: 100px;
        `,
    },
};

productCarouselProductFullStyles.productUnitOfMeasureSelectStyles = {
    cssOverrides: {
        formField: css`
            width: 84px;
            min-width: 84px;
        `,
        inputSelect: css`
            height: 33px;
        `,
    },
};

productCarouselProductFullStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
        padding-inline: 10px;
    `,
};

productCarouselProductFullStyles.addToContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
        width: 100%;
    `,
};
